// Centralizes the `submit-click` analytics payload shape shared by six live-agent/survey
// call sites. See .claude/context/live-agent.md "The shared submit-click shape".
import { createActionId } from '../platform/session/session';
import { emit } from '../platform/events/lifecycle';

/**
 * Emit a live-agent / survey lifecycle analytics event (the `submit-click` shape).
 * @param {Object} params
 * @param {string} params.lvQuestion       the analytics discriminator string
 * @param {string} params.sessionId        maps to payload `sessionID`
 * @param {string} [params.actionId]       maps to payload `actionID`; defaults to createActionId(sessionId)
 * @param {string} params.conversationId   maps to payload `sprinklrSession`
 * @param {string} params.caseNumber       maps to payload `sprinklrCase`
 */
export const emitLiveAgentAnalytics = ({
  lvQuestion, sessionId, actionId, conversationId, caseNumber,
}) => {
  emit('magic-apron-assistant.submit-click', {
    lvQuestion,
    sessionID: sessionId,
    actionID: actionId ?? createActionId(sessionId),
    sprinklrSession: conversationId,
    sprinklrCase: caseNumber,
  });
};
